import { InvoiceStatus } from '@principle-theorem/principle-core/interfaces';
import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import { IAppointmentDimension } from '../dimensions/appointment';
import {
  IBaseEventFact,
  IBigQueryInvoicePracitionerSummary,
  IBigQueryPaymentPracitionerSummary,
  IInvoiceScopedFact,
} from './common';

export interface IInvoiceEventFact
  extends IInvoiceScopedFact,
    IBaseEventFact<string, InvoiceStatus | undefined> {
  amountRemaining: number;
  paidToDate: number;
  completedTransactions: number;
  discounts: number;
  amountPayable: number;
  isOverdue: boolean;
  overdueBy?: number;
  subTotal: number;
  tax: number;
  total: number;
  issuedAt?: ISerialisedTimestamp;
  paidOnCheckout: boolean;
  treatmentPlans: ISerialisedDocumentReference[];
  appointmentRefs: ISerialisedDocumentReference[];
  appointments: IAppointmentDimension[];
  practitionerFees: IBigQueryInvoicePracitionerSummary[];
  practitionerPayment: IBigQueryPaymentPracitionerSummary[];
}
